import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TicketFlag, TicketMediaType, TicketService, FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { TicketListItemModule } from '@fgb/portal-component-library/src/lib/tickettransfer/ticket-list-item';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@fgb/core';
import * as ɵngcc2 from '@angular/common';
import * as ɵngcc3 from '@fgb/portal-component-library/src/lib/tickettransfer/ticket-list-item';
import * as ɵngcc4 from '@ngx-translate/core';

function TicketListComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "input", 3);
    ɵngcc0.ɵɵlistener("change", function TicketListComponent_div_0_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.selectAll(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("checked", !ctx_r0.anyUnselected);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 2, "cl.ticket.list.select.all.tickets"));
} }
function TicketListComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "fgbcl-ticket-list-item", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ticket_r4 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ticket", ticket_r4)("transferWindowExists", ctx_r1.transferWindowExists)("transferWindowOpen", ctx_r1.transferWindowOpen);
} }
class TicketListComponent {
    constructor(ticketService) {
        this.ticketService = ticketService;
        this.ticketFlag = TicketFlag;
    }
    get anyUnselected() {
        return this.tickets.some(t => !t.selected && t.Flag === this.ticketFlag.ACTIVE && t.MediaType === TicketMediaType.CARD);
    }
    ngOnInit() {
        this.ticketService.resetTransferredTickets();
    }
    selectAll() {
        this.ticketService.toggleSelectAllTickets(this.tickets[0].GameNumber, this.anyUnselected);
    }
}
TicketListComponent.ɵfac = function TicketListComponent_Factory(t) { return new (t || TicketListComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.TicketService)); };
TicketListComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TicketListComponent, selectors: [["fgbcl-ticket-list"]], inputs: { tickets: "tickets", pastGame: "pastGame", transferWindowExists: "transferWindowExists", transferWindowOpen: "transferWindowOpen" }, decls: 2, vars: 2, consts: [["class", "ticket-list-select-all", 4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "ticket-list-select-all"], ["type", "checkbox", "id", "selectAll", "name", "selectAll", 3, "checked", "change"], ["for", "selectAll"], [3, "ticket", "transferWindowExists", "transferWindowOpen"]], template: function TicketListComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TicketListComponent_div_0_Template, 5, 4, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TicketListComponent_ng_container_1_Template, 2, 3, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.transferWindowExists && ctx.transferWindowOpen && !ctx.pastGame);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.tickets);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc3.TicketListItemComponent], pipes: [ɵngcc4.TranslatePipe], styles: [""] });
TicketListComponent.ctorParameters = () => [
    { type: TicketService }
];
TicketListComponent.propDecorators = {
    tickets: [{ type: Input }],
    pastGame: [{ type: Input }],
    transferWindowExists: [{ type: Input }],
    transferWindowOpen: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketListComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-ticket-list',
                template: "<div class=\"ticket-list-select-all\" *ngIf=\"transferWindowExists && transferWindowOpen && !pastGame\">\r\n  <input type=\"checkbox\" id=\"selectAll\" name=\"selectAll\" (change)=\"selectAll()\" [checked]=\"!anyUnselected\" />\r\n  <label for=\"selectAll\">{{ 'cl.ticket.list.select.all.tickets' | translate }}</label>\r\n</div>\r\n<ng-container *ngFor=\"let ticket of tickets\">\r\n  <fgbcl-ticket-list-item\r\n    [ticket]=\"ticket\"\r\n    [transferWindowExists]=\"transferWindowExists\"\r\n    [transferWindowOpen]=\"transferWindowOpen\"\r\n  ></fgbcl-ticket-list-item>\r\n</ng-container>\r\n",
                styles: [""]
            }]
    }], function () { return [{ type: ɵngcc1.TicketService }]; }, { tickets: [{
            type: Input
        }], pastGame: [{
            type: Input
        }], transferWindowExists: [{
            type: Input
        }], transferWindowOpen: [{
            type: Input
        }] }); })();

class TicketListModule {
}
TicketListModule.ɵfac = function TicketListModule_Factory(t) { return new (t || TicketListModule)(); };
TicketListModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TicketListModule });
TicketListModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TicketListItemModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TicketListModule, { declarations: function () { return [TicketListComponent]; }, imports: function () { return [CommonModule,
        TicketListItemModule, ɵngcc4.TranslateModule]; }, exports: function () { return [TicketListComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketListModule, [{
        type: NgModule,
        args: [{
                declarations: [TicketListComponent],
                imports: [
                    CommonModule,
                    TicketListItemModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [TicketListComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TicketListComponent, TicketListModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-ticket-list.js.map